<div [ngSwitch]="type">
  <app-itinerary-resume
    *ngSwitchCase="optionType.Split"
    [passengers]="operation?.result?.pnr?.passenger"
    [flights]="operation?.result?.pnr?.segments"
    flightsTitle="{{ 'special-requests.flights-resume-title' | translate }}"
  >
  </app-itinerary-resume>

  <div *ngSwitchCase="optionType.SpecialRequest">
    <div *ngFor="let confirmation of operation.result?.confirmations">
      <app-flight-special-requests
        [specialRequest]="confirmation.specialRequest"
        [showBoth]="true"
        [passenger]="
          confirmation.passenger.firstName +
          ' ' +
          confirmation.passenger.lastName
        "
      ></app-flight-special-requests>
    </div>
  </div>

  <div *ngSwitchCase="optionType.Cancellation">
    <app-cancellation-quote-resume
    [cancellationQuote]="operation?.result?.cancellationQuote"
    ></app-cancellation-quote-resume>
  </div>
</div>
